const LearnMoreIcon = () => {
    return (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 14">
            <g isolation="isolate">
                <path
                    d="M18,1.84V11.12c0,.98-.79,1.79-1.81,1.84-1.09,.05-3.81,.26-5.68,.95-.17,.06-.33,.09-.51,.09h-2c-.18,0-.34-.03-.51-.09-1.87-.69-4.6-.89-5.68-.95-1.01-.05-1.81-.86-1.81-1.84V1.84C0,.83,.86,0,1.91,0h0c.75,0,4.52,.28,6.86,1.5,.13,.07,.32,.07,.45,0C11.56,.28,15.33,0,16.09,0h0c1.05,0,1.91,.83,1.91,1.84ZM8.5,6.2V3.07c0-.38-.24-.71-.59-.87C5.74,1.23,2.51,1,1.91,1c-.5,0-.91,.38-.91,.84V11.12c0,.45,.38,.82,.86,.84,1.34,.07,4.05,.29,6,1.02,.06,.02,.11,.03,.17,.03,.25,0,.48-.2,.48-.47V6.2ZM17,1.84c0-.47-.41-.84-.91-.84-.6,0-3.83,.23-6,1.2-.35,.16-.58,.49-.58,.87v3.14s0,6.33,0,6.33c0,.27,.22,.47,.48,.47,.06,0,.11,0,.17-.03,1.95-.73,4.66-.95,6-1.02,.48-.02,.86-.39,.86-.84V1.84Z"
                    fill="#7f7f7f"/>
            </g>
        </svg>

    );
}
export default LearnMoreIcon;
